import { useEffect, useState } from 'react';

import Aos from 'aos';
import 'aos/dist/aos.css';
import {  Link, useLocation } from 'react-router-dom';
import CountUp from 'react-countup';

import lottie from '../lottie/dex.json'
import lottieJson from '../lottie/dex-vm.json'
import NewsLetter from './NewsLetter';
import Lottie from 'react-lottie-player';

import data from "../Data/data.json";
import { CountDown } from './CountDown';
import BuyButtons from '../components/BuyButtons';

interface Item {
  name: string;
  image: string;
  link: string;
}

interface Category {
  name: string;
  items: Item[];
}

const Home = () => {

  
  const [domReady, setDomReady] = useState(false);
  const [categories, setCategories] = useState<Category[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string>("Featured dApps");

  const excludedCategories = [
    "nft, gaming & ai", 
    "data availability", 
    "security", 
    "clients"
  ];

  const featuredAppsCategory: Category = {
    name: "Featured dApps",
    items: [
      {
        name: "Avail Network",
        image: "assets/partner/app4.svg",
        link: "https://www.availproject.org/"
      },
      {
        name: "BitLen",
        image: "assets/partner/app3.svg",
        link: "https://testnet.bitlen.io/"
      },
      {
        name: "Bitomni",
        image: "assets/ecosystem/apps/ap5.png",
        link: "https://bitomni.io/en"
      },
      {
        name: "Blockscout",
        image: "assets/partner/app5.svg",
        link: "https://www.blockscout.com/"
      },
      {
        name: "IceCreamSwap",
        image: "assets/partner/app1.svg",
        link: "https://icecreamswap.com/"
      },
      
    ]
  };

  const handleCategorySelect = (categoryName: string) => {
    setSelectedCategory(categoryName);
  };

  let filteredCategories = data.categories.filter(category =>
    !excludedCategories.includes(category.name.toLowerCase()) &&
    (selectedCategory !== "Featured dApps" && category.name.toLowerCase() === selectedCategory.toLowerCase())
  );

  if (selectedCategory === "Featured dApps") {
    filteredCategories = [featuredAppsCategory];
  }

  useEffect(() => {
    setCategories(data.categories);
  }, []);

  useEffect(() => {
    setDomReady(true);
  }, []);
  

  useEffect(function () {
    Aos.init({ disable: 'mobile' });
  }, []);

  const location = useLocation();

  useEffect(() => {
  window.scrollTo(0, 0);
  if (location.hash) {
    const element = document.querySelector(location.hash);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
  }, [location]);


  return (
    <>
      {/* Banner */}
      <div className="bg-grad">
        <img src="assets/b1.png" className='b1-img' alt="" />
        <section className="banner home-banner" id="home">
        <img src="assets/b2.png" className='b2-img' alt="" />
          <div className="container">
          <div className="row align-items-center position-relative z-index-2">
              <div className="col-md-6 mb-md-0 mb-4" data-aos="fade-up" data-aos-duration="1800">
                <h1 className="mb-0">
                Build DeFi on 
                <br /> <span className="danger-text">Bitcoin</span>
                </h1>

                <div className="d-md-none d-block mt-4">
                <img src="assets/herosm.png" className='w-100 op-dark' alt="" />
              <img src="assets/herosm-vm.png" className='w-100 op-light' alt="" />
                </div>
                <p className="my-4 pe-lg-5">
                Layer 2 solution designed to unlock the full  potential
                of DeFi on the world’s most secure blockchain network.
                </p>
                <BuyButtons />
                {/* <div className='text-md-start text-center'>
                <div className="sp-img op-dark"><img src="assets/sp.svg" alt="" /></div>
                <div className="sp-img op-light"><img src="assets/sp-vm.svg" alt="" /></div>
                </div> */}
                
              </div>

              <div className="col-md-5 offset-lg-1" data-aos="zoom-in" data-aos-duration="1800">
              <div className="d-md-block d-none">
              <Lottie className='op-dark'
                  loop
                  animationData={lottie}
                  play
                  style={{ width: '100%', height: '100%' }}
                />
                <Lottie className='op-light'
                  loop
                  animationData={lottieJson}
                  play
                  style={{ width: '100%', height: '100%' }}
                />
                </div>
                
              
              </div>
              
            </div>
          </div>
        </section>
        </div>

        <section className='blackBg py-4 feature'>
          <div className="container py-lg-2">
            <h5 className='text-center  mb-3' >As featured in</h5>
            <div className="row align-items-center justify-content-center text-md-start text-center">
            <div className="col-md-2 col-4 mb-md-0 mb-3 px-1 px-md-2">
              <img src="assets/partner/p33.png" className='op-dark w-100'  alt="" />
              <img src="assets/partner/p33-vm.png" className='op-light w-100'  alt="" />              
              </div>
              <div className="col-md-2 col-4 mb-md-0 mb-3">
              <img src="assets/partner/pb6.png" className='op-dark w-100 px-md-1' alt="" />
              <img src="assets/partner/pb6-vm.png" className='op-light w-100 px-md-1' alt="" />              
              </div>
              <div className="col-md-1 col-3 mb-md-0 mb-3 pe-0">
              <img src="assets/partner/p1.png" className='op-dark w-100' alt="" />
              <img src="assets/partner/p1-vm.png" className='op-light w-100' alt="" />              
              </div>
              <div className="col-md-2 col-3 text-md-end mb-md-0 mb-3">
              <img src="assets/partner/p2.png" className='op-dark' height={30} alt="" />
              <img src="assets/partner/p2-vm.png" className='op-light' height={30} alt="" />              
              </div>
              <div className="col-md-3 col-5 mb-md-0 mb-3">
              <img src="assets/partner/p4.png" className='op-dark w-100' alt="" />
              <img src="assets/partner/p4-vm.png" className='op-light w-100' alt="" />              
              </div>
              
              <div className="col-md-2 col-4 mb-md-0 mb-3">
              <img src="assets/partner/p6.png" className='op-dark w-100' alt="" />
              <img src="assets/partner/p6-vm.png" className='op-light w-100' alt="" />              
              </div>
              
            </div>
          </div>
        </section>

        <section className='py-5 my-lg-3 px-md-0 px-3'>
          <div className="container">
            <h2 className='mb-4' >StratoVM Testnet</h2>
            <div className="row">
              <div className="col-lg-3 col-md-6 mb-lg-0 mb-md-4 mb-2">
                <div className="test-card">
                  <div className="icon"><svg width="48" height="47" viewBox="0 0 48 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="48" height="47" rx="10" fill="#F19938" fill-opacity="0.6"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M27.9516 12.4266C27.4774 11.955 26.8353 11.69 26.1663 11.69C24.3412 11.69 19.3791 11.69 16.75 11.69C15.3519 11.69 14.2188 12.8232 14.2188 14.2213V31.384C14.2188 32.3577 14.7773 33.2453 15.6557 33.6663C16.534 34.0874 17.5752 33.9676 18.3346 33.3575L18.7531 33.0217C19.0619 32.7745 19.5006 32.7745 19.8094 33.0217L21.9171 34.7143C22.8419 35.4568 24.1573 35.4576 25.0837 34.7168L27.1931 33.0293C27.5011 32.7829 27.9381 32.7821 28.2461 33.0285L28.6832 33.3769C29.4434 33.9836 30.4837 34.1009 31.3604 33.679C32.2362 33.2571 32.7931 32.3703 32.7931 31.3983V18.2949C32.7931 17.6216 32.5248 16.9761 32.0472 16.5011L27.9516 12.4266ZM25.1875 13.3775H16.75C16.2843 13.3775 15.9063 13.7547 15.9063 14.2213V31.384C15.9063 31.7088 16.0927 32.0042 16.3855 32.1451C16.6783 32.2851 17.0251 32.2455 17.2782 32.0421C17.4233 31.9257 17.5634 31.8126 17.6967 31.7063C18.6223 30.963 19.9402 30.963 20.8658 31.7063L22.9735 33.3989C23.2815 33.6461 23.7202 33.6461 24.029 33.3997L26.1384 31.7114C27.0623 30.9722 28.3743 30.9714 29.2991 31.7088L29.7362 32.0573C29.9893 32.2598 30.3361 32.2986 30.628 32.1586C30.9199 32.0176 31.1056 31.7223 31.1056 31.3983V19.2812H27.7188C27.0471 19.2812 26.4033 19.0146 25.9292 18.5396C25.4541 18.0654 25.1875 17.4216 25.1875 16.75V13.3775ZM25.8127 29.9741L28.3153 27.4715C28.5566 27.2302 28.6292 26.8674 28.4984 26.5518C28.3676 26.2371 28.0596 26.0312 27.7188 26.0312H19.2813C18.8155 26.0312 18.4375 26.4092 18.4375 26.875C18.4375 27.3407 18.8155 27.7187 19.2813 27.7187H25.6819L24.6197 28.781C24.2897 29.1101 24.2897 29.645 24.6197 29.9741C24.9487 30.304 25.4837 30.304 25.8127 29.9741ZM21.1873 20.4009L18.6847 22.9035C18.4434 23.1448 18.3708 23.5076 18.5016 23.8231C18.6324 24.1379 18.9404 24.3437 19.2813 24.3437H27.7188C28.1845 24.3437 28.5625 23.9657 28.5625 23.5C28.5625 23.0342 28.1845 22.6562 27.7188 22.6562H21.3181L22.3803 21.594C22.7103 21.2649 22.7103 20.73 22.3803 20.4009C22.0513 20.071 21.5163 20.071 21.1873 20.4009ZM26.875 13.7353V16.75C26.875 16.9736 26.9636 17.1887 27.1222 17.3465C27.28 17.5052 27.4952 17.5937 27.7188 17.5937H30.7529L26.875 13.7353Z" fill="white"/>
                    </svg>
                    </div>
                  <div className="detail">
                    <h4> 2,{domReady && <CountUp  end={219} enableScrollSpy />},{domReady && <CountUp end={159} enableScrollSpy />}</h4>
                    <p className='mb-0'>Total transactions</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-lg-0 mb-md-4 mb-2">
                <div className="test-card">
                  <div className="icon"><svg width="48" height="47" viewBox="0 0 48 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="48" height="47" rx="10" fill="#F19938" fill-opacity="0.6"/>
                    <path d="M31.3125 13.7344H15.6875C15.0659 13.7344 14.4698 13.9813 14.0302 14.4208C13.5907 14.8604 13.3438 15.4565 13.3438 16.0781V30.9219C13.3438 31.5435 13.5907 32.1396 14.0302 32.5792C14.4698 33.0187 15.0659 33.2656 15.6875 33.2656H31.3125C31.9341 33.2656 32.5302 33.0187 32.9698 32.5792C33.4093 32.1396 33.6562 31.5435 33.6562 30.9219V16.0781C33.6562 15.4565 33.4093 14.8604 32.9698 14.4208C32.5302 13.9813 31.9341 13.7344 31.3125 13.7344ZM32.0938 30.9219C32.0938 31.1291 32.0114 31.3278 31.8649 31.4743C31.7184 31.6208 31.5197 31.7031 31.3125 31.7031H15.6875C15.4803 31.7031 15.2816 31.6208 15.1351 31.4743C14.9886 31.3278 14.9062 31.1291 14.9062 30.9219V16.0781C14.9062 15.8709 14.9886 15.6722 15.1351 15.5257C15.2816 15.3792 15.4803 15.2969 15.6875 15.2969H31.3125C31.5197 15.2969 31.7184 15.3792 31.8649 15.5257C32.0114 15.6722 32.0938 15.8709 32.0938 16.0781V30.9219Z" fill="white"/>
                    <path d="M28.5787 22.3281C28.7859 22.3281 28.9847 22.2458 29.1312 22.0993C29.2777 21.9528 29.36 21.7541 29.36 21.5469C29.36 21.3397 29.2777 21.141 29.1312 20.9945C28.9847 20.8479 28.7859 20.7656 28.5787 20.7656H19.9186L20.9303 19.7539C21.0769 19.6073 21.1593 19.4085 21.1593 19.2012C21.1593 18.9939 21.0769 18.795 20.9303 18.6484C20.7837 18.5019 20.5849 18.4195 20.3776 18.4195C20.1703 18.4195 19.9714 18.5019 19.8248 18.6484L17.4811 20.9922C17.3712 21.1012 17.2961 21.2405 17.2655 21.3923C17.2348 21.544 17.25 21.7015 17.309 21.8447C17.368 21.9878 17.4682 22.1102 17.5969 22.1963C17.7256 22.2824 17.877 22.3283 18.0319 22.3281H28.5787Z" fill="white"/>
                    <path d="M29.3594 25.0625H18.8125C18.6053 25.0625 18.4066 25.1448 18.2601 25.2913C18.1136 25.4378 18.0312 25.6365 18.0312 25.8438C18.0312 26.051 18.1136 26.2497 18.2601 26.3962C18.4066 26.5427 18.6053 26.625 18.8125 26.625H27.4727L26.4609 27.6367C26.3143 27.7833 26.232 27.9821 26.232 28.1895C26.232 28.3968 26.3143 28.5956 26.4609 28.7422C26.6075 28.8888 26.8064 28.9711 27.0137 28.9711C27.221 28.9711 27.4198 28.8888 27.5664 28.7422L29.9102 26.3984C30.0201 26.2894 30.0951 26.1501 30.1258 25.9984C30.1564 25.8466 30.1413 25.6891 30.0823 25.546C30.0233 25.4028 29.923 25.2804 29.7943 25.1943C29.6656 25.1083 29.5142 25.0624 29.3594 25.0625Z" fill="white"/>
                    </svg>
                    </div>
                  <div className="detail">
                    <h4>56,{domReady && <CountUp  end={211} enableScrollSpy />}</h4>
                    <p className='mb-0'>Daily transactions</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-lg-0 mb-md-4 mb-2">
                <div className="test-card">
                  <div className="icon"><svg width="48" height="47" viewBox="0 0 48 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="48" height="47" rx="10" fill="#F19938" fill-opacity="0.6"/>
                      <g clip-path="url(#clip0_19_3)">
                      <path d="M34.5938 23.4957V20.6662C34.5938 19.2761 33.4876 18.14 32.1094 18.0905V16.3537C32.1094 15.449 31.3734 14.7131 30.4688 14.7131H25.952L25.3687 13.0918C25.22 12.6784 24.9189 12.348 24.5211 12.1616C24.1232 11.9751 23.6767 11.9552 23.2638 12.1055L15.0675 15.0887C14.6551 15.2388 14.3261 15.5406 14.141 15.9386C13.956 16.3365 13.9372 16.7826 14.0881 17.1948L14.4174 18.0936C13.0705 18.1769 12 19.2986 12 20.6662V33.4162C12 34.8378 13.1565 35.9943 14.5781 35.9943H32.0156C33.4372 35.9943 34.5938 34.8378 34.5938 33.4162V30.4929C35.3877 30.3788 36 29.6944 36 28.8693V25.1193C36 24.2943 35.3877 23.6098 34.5938 23.4957ZM34.5938 28.8693C34.5938 28.9985 34.4886 29.1037 34.3594 29.1037H30.6094C29.4463 29.1037 28.5 28.1574 28.5 26.9943C28.5 25.8312 29.4463 24.8849 30.6094 24.8849H34.3594C34.4886 24.8849 34.5938 24.9901 34.5938 25.1193V28.8693ZM15.4086 16.711C15.3795 16.6316 15.4008 16.5645 15.4161 16.5315C15.4314 16.4986 15.469 16.439 15.5485 16.4101L23.7448 13.427C23.8244 13.398 23.8914 13.4195 23.9244 13.435C23.9573 13.4504 24.0168 13.4882 24.0455 13.5679L24.4575 14.7131H24.1406C23.236 14.7131 22.5 15.4491 22.5 16.3537V18.0881H15.9131L15.4086 16.711ZM30.7031 16.3537V18.0881H23.9062V16.3537C23.9062 16.2245 24.0114 16.1193 24.1406 16.1193H30.4688C30.598 16.1193 30.7031 16.2245 30.7031 16.3537ZM32.0156 34.5881H14.5781C13.932 34.5881 13.4062 34.0624 13.4062 33.4162V20.6662C13.4062 20.02 13.932 19.4943 14.5781 19.4943H32.0156C32.6618 19.4943 33.1875 20.02 33.1875 20.6662V23.4787H30.6094C28.6709 23.4787 27.0938 25.0558 27.0938 26.9943C27.0938 28.9328 28.6709 30.5099 30.6094 30.5099H33.1875V33.4162C33.1875 34.0624 32.6618 34.5881 32.0156 34.5881Z" fill="white"/>
                      <path d="M30.6094 27.6974C30.9977 27.6974 31.3125 27.3826 31.3125 26.9943C31.3125 26.606 30.9977 26.2912 30.6094 26.2912C30.221 26.2912 29.9062 26.606 29.9062 26.9943C29.9062 27.3826 30.221 27.6974 30.6094 27.6974Z" fill="white"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_19_3">
                      <rect width="24" height="24" fill="white" transform="translate(12 12)"/>
                      </clipPath>
                      </defs>
                      </svg>
                    </div>
                  <div className="detail">
                    <h4>113,{domReady && <CountUp  end={312} enableScrollSpy />}</h4>
                    <p className='mb-0 '>Wallet addresses</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-lg-0 mb-md-4 mb-2">
                <div className="test-card">
                  <div className="icon"><svg width="48" height="47" viewBox="0 0 48 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="48" height="47" rx="10" fill="#F19938" fill-opacity="0.6"/>
                  <g clip-path="url(#clip0_19_4)">
                  <path d="M23.5001 12.0002C17.1587 12.0002 12 17.1593 12 23.5006C12.0005 29.8413 17.1595 35 23.5001 35C29.8412 35 35.0001 29.8414 35.0001 23.5005C35 17.1593 29.8412 12.0002 23.5001 12.0002ZM23.5001 13.6015C25.8508 13.6015 28.0123 14.4257 29.7121 15.7997L15.7996 29.7121C14.4258 28.0124 13.6015 25.851 13.6013 23.5005C13.6013 18.0422 18.0419 13.6015 23.5001 13.6015ZM23.5001 33.3987C20.9681 33.3987 18.6556 32.4427 16.9032 30.8732L30.8731 16.9033C32.4427 18.6557 33.3987 20.9685 33.3987 23.5006C33.3987 28.9584 28.9581 33.3987 23.5001 33.3987Z" fill="white"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_19_4">
                  <rect width="23" height="23" fill="white" transform="translate(12 12)"/>
                  </clipPath>
                  </defs>
                  </svg>
                    </div>
                  <div className="detail">
                    <h4> 1,{domReady && <CountUp  end={937} enableScrollSpy />},{domReady && <CountUp  end={243} enableScrollSpy />}</h4>
                    <p className='mb-0'>Total blocks</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className='bg3'>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 text-center">
                <h2 className='mb-3 px-lg-5'>Building Together: Shaping the Future of Finance on Bitcoin</h2>
                <p className='mb-lg-5 mb-4 ' >StratoVM revolutionizes DeFi with enhanced interoperability, speed, and user experience. 
                  As a Bitcoin Layer 2 solution, it enables fast transactions with instant finality, 
                  addressing slow trade execution and high costs. Developer-friendly, StratoVM supports 
                  custom smart contracts and new market listings, driving the future of DeFi on Bitcoin.</p>

                <a href="#ecoSystem" className='primary-btn'>Explore Ecosystem</a>
              </div>
            </div>
            <div className="row justify-content-center align-items-center mt-lg-5 mt-4 pt-lg-5">
                    <div className="col-md-2 px-md-0 px-4 col-6 mb-4 mb-md-5 text-center">
                    <img src="assets/partner/pb2.png" className='op-dark w-100 px-3' alt="" />
                    <img src="assets/partner/pb2-vm.png" className='op-light w-100 px-3' alt="" />  
                    </div>
                    <div className="col-md-2 col-6 mb-4 mb-md-5 text-center">
                    <img src="assets/partner/npb1.png" className='op-dark w-100 px-md-0 px-4' alt="" />
                    <img src="assets/partner/npb1-vm.png" className='op-light w-100 px-md-0 px-4' alt="" />  
                    </div>
                    <div className="col-md-2 col-6 mb-4 mb-md-5 text-center">
                    <img src="assets/partner/pb5.png" className='op-dark w-100 px-md-2 px-4' alt="" />
                    <img src="assets/partner/pb5-vm.png" className='op-light w-100 px-md-2 px-4' alt="" />  
                    </div>
                    <div className="col-md-2 col-6 mb-4 mb-md-5 text-center">
                    <img src="assets/partner/pb10.png" className='op-dark w-100 px-md-3 px-4' alt="" />
                    <img src="assets/partner/pb10-vm.png" className='op-light w-100 px-md-3 px-4' alt="" />  
                    </div>
                    
                    <div className="col-md-2 col-6 mb-4 mb-md-5 text-center">
                    <img src="assets/partner/taker.png" className='op-dark w-100 px-md-0 px-3' alt="" />
                    <img src="assets/partner/taker-vm.png" className='op-light w-100 px-md-0 px-3' alt="" />  
                    </div>
                    <div className="col-md-2 col-6 mb-4 mb-md-5 text-center">
                    <img src="assets/partner/pie.png" className='op-dark w-100 px-md-2 px-4' alt="" />
                    <img src="assets/partner/pie-vm.png" className='op-light w-100 px-md-2 px-4' alt="" />  
                    </div>
                    
                   
                    <div className="col-md-3 col-6 mb-4 mb-md-5 text-center">
                    <img src="assets/partner/npb3.png" className='op-dark w-100 px-md-4 px-2' alt="" />
                    <img src="assets/partner/npb3-vm.png" className='op-light w-100 px-md-4 px-2' alt="" />  
                    </div>
                    <div className="col-md-3 col-6 mb-4 mb-md-5  text-center">
                    <img src="assets/partner/pb3.png" className='op-dark w-100 px-md-0 px-3' alt="" />
                    <img src="assets/partner/pb3-vm.png" className='op-light w-100 px-md-0 px-3' alt="" />  
                    </div>
                    <div className="col-md-3 col-6 mb-md-5 text-center">
                    <img src="assets/partner/ice.png" className='op-dark w-100 px-md-2' alt="" />
                    <img src="assets/partner/ice-vm.png" className='op-light w-100 px-md-2' alt="" />  
                    </div>
                    <div className="col-md-3 col-6 mb-md-5 text-center">
                    <img src="assets/partner/npb4.png" className='op-dark w-100 px-md-0 px-2' alt="" />
                    <img src="assets/partner/npb4-vm.png" className='op-light w-100 px-md-0 px-2' alt="" />  
                    </div>
                    
                  </div>
          </div>
        </section>


        <section className='apps py-5 mt-lg-4' id='apps'>
        <div className="container">
      <div className="row">
        <div className="col-md-6 pe-lg-5 mb-md-0 mb-4">
          <h2 className="mb-4">Create best <br/>
          in-class <br/> financial apps</h2>
          <div className="pe-lg-5 mb-lg-5">
            <div className="nav flex-column gap-3 nav-pills" 
              id="v-pills-tab" role="tablist" aria-orientation="vertical">
              <button className="nav-link active" id="v-pills-home-tab" data-bs-toggle="pill"
                data-bs-target="#v-pills-home" type="button" role="tab" aria-controls="v-pills-home"
                aria-selected="true">
                      <div>The Ultimate Dev Playground</div>
                      <svg width="53" height="13" viewBox="0 0 53 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M53 6.5L43 0.726497V12.2735L53 6.5ZM0 7.5H44V5.5H0V7.5Z" fill="white"/>
                        </svg>
              </button>
              <button className="nav-link" id="v-pills-profile-tab" data-bs-toggle="pill"
                data-bs-target="#v-pills-profile" type="button" role="tab" aria-controls="v-pills-profile"
                aria-selected="false">
                <div>Onchain Economy</div>
                      <svg width="53" height="13" viewBox="0 0 53 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M53 6.5L43 0.726497V12.2735L53 6.5ZM0 7.5H44V5.5H0V7.5Z" fill="white"/>
                        </svg>
              </button>
              <button className="nav-link" id="v-pills-messages-tab" data-bs-toggle="pill"
                data-bs-target="#v-pills-messages" type="button" role="tab" aria-controls="v-pills-messages"
                aria-selected="false">
                <div>Revolutionize Your DeFi Experience</div>
                      <svg width="53" height="13" viewBox="0 0 53 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M53 6.5L43 0.726497V12.2735L53 6.5ZM0 7.5H44V5.5H0V7.5Z" fill="white"/>
                        </svg>
              </button>
              <button className="nav-link" id="v-pills-messages-tab1" data-bs-toggle="pill"
                data-bs-target="#v-pills-messages1" type="button" role="tab" aria-controls="v-pills-messages1"
                aria-selected="false">
                <div>Unlock EVM Compatibility with StratoVM</div>
                      <svg width="53" height="13" viewBox="0 0 53 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M53 6.5L43 0.726497V12.2735L53 6.5ZM0 7.5H44V5.5H0V7.5Z" fill="white"/>
                        </svg>
              </button>
            </div>
          </div>
          <div className="d-md-block d-none mt-md-3 mt-lg-0">
          <a href="https://docs.stratovm.io/stratovm-sdk/getting-started/deploying-your-first-contract-on-stratovm-sepolia" 
          target={"_blank"} className='primary-btn px-lg-5'><span
              className="px-lg-3">Start Building</span></a>
          </div>
        </div>
        <div className="col-md-6 pb-lg-5">
          <div className="tab-content mb-md-4" id="v-pills-tabContent">
            <div className="tab-pane fade show active" id="v-pills-home" role="tabpanel"
              aria-labelledby="v-pills-home-tab">
          <div className="text-center mb-lg-5 mb-4">
          <img src="assets/best.png" className='w-100 mx-350 op-dark' alt="" />
          <img src="assets/best-vm.png" className='w-100 mx-350 op-light' alt="" />
          </div>
                <h4 className='primary-text  mb-4'>The Ultimate Dev Playground</h4>
              <p className=''>Explore the convergence of Bitcoin and EVM with top-tier developer tools, analytics, 
                wallets, and blockchain infrastructure. Accelerate from concept to mainnet with unprecedented speed, 
                all enabled by StratoVM's technology—your essential toolkit for Bitcoin and EVM smart contracts.</p>
            </div>
            <div className="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
            <div className="text-center mb-lg-5 mb-4">
          <img src="assets/best1.png" className='w-100 mx-420 op-dark' alt="" />
          <img src="assets/best1-vm.png" className='w-100 mx-420 op-light' alt="" />
          </div>
            <h4 className='primary-text  mb-4'>Onchain Economy</h4>
              <p className=''>Build applications on Bitcoin combining unparalleled security and decentralization of 
                the Bitcoin network with the scalability of an L2 solution. Leverage the security of the Bitcoin 
                network by storing data hashes on the Bitcoin blockchain.</p>
            </div>
            <div className="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
            <div className="text-center mb-lg-5 mb-4">
          <img src="assets/best2.png" className='w-100 mx-420 op-dark' alt="" />
          <img src="assets/best2-vm.png" className='w-100 mx-420 op-light' alt="" />
          </div>
            <h4 className='primary-text  mb-4'>Revolutionize Your DeFi Experience</h4>
              <p className=''>StratoVM offers a diverse array of novel Web3 modules and primitives, allowing developers to 
                build sophisticated dApps with ease. From DEXs and lending protocols to perpetual contracts and more, 
                our plug-and-play modules and deep liquidity support enable seamless creation and deployment of 
                customized DeFi solutions from day one.</p>
            </div>
            <div className="tab-pane fade" id="v-pills-messages1" role="tabpanel" aria-labelledby="v-pills-messages-tab1">
            <div className="text-center mb-lg-5 mb-4">
          <img src="assets/best3.png" className='w-100 mx-350 op-dark' alt="" />
          <img src="assets/best3-vm.png" className='w-100 mx-350 op-light' alt="" />
          </div>
            <h4 className='primary-text  mb-4'>Unlock EVM Compatibility with StratoVM</h4>
              <p className=''>StratoVM offers 2-second block times and EVM-equivalent compatibility, 
                allowing seamless migration of dApps from Ethereum to Bitcoin. Enjoy lightning-fast transactions, 
                under $0.001 costs, and robust modular DeFi solutions for unparalleled growth and efficiency.</p>
            </div>
          </div>
          <div className="d-md-none d-block">
          <a href="https://docs.stratovm.io/stratovm-sdk/getting-started/deploying-your-first-contract-on-stratovm-sepolia" 
          target={"_blank"} className='primary-btn px-lg-5'><span
              className="px-lg-3">Start Building</span></a>
          </div>
        </div>

      </div>
      
    </div>

    <div className="container pt-lg-4" id='ecoSystem'>
      <div className="eco-card mt-5">
        <div className="row">
          <div className="col-md-6 mb-md-5 mb-3">
              <h2>Discover <br /> the ecosystem</h2>
          </div>
          <div className="col-md-6 mb-md-5 mb-0">
            <p className=''>StratoVM is powered by a global network of developers, validators, builders, 
              institutions and partners. Explore the fastest growing community pioneering a new world of BTCFi.</p>
          </div>
          <div className="col-md-12">
              <div className="eco-pills">
              <div className="d-md-none d-block">
                  <button className="primary-btn-outline w-100" data-bs-toggle="modal" data-bs-target="#exampleModal">{selectedCategory &&<div>{selectedCategory}</div>}
                  <svg width="53" height="13" viewBox="0 0 53 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M53 6.5L43 0.726497V12.2735L53 6.5ZM0 7.5H44V5.5H0V7.5Z" fill="white"></path></svg>
                  </button>
                  </div>
            <div className="responsive-table">
              <ul className="nav nav-tabs d-md-flex d-none" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" 
                      type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Featured dApps</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" 
                      type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">DeFi</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact-tab-pane" 
                      type="button" role="tab" aria-controls="contact-tab-pane" aria-selected="false">Infra & Tooling</button>
                    </li>

                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="contact-tab1" data-bs-toggle="tab" data-bs-target="#contact-tab1-pane" 
                      type="button" role="tab" aria-controls="contact-tab1-pane" aria-selected="false">Wallets</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="contact-tab2" data-bs-toggle="tab" data-bs-target="#contact-tab2-pane" 
                      type="button" role="tab" aria-controls="contact-tab2-pane" aria-selected="false">Bridge</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" id="contact-tab3" data-bs-toggle="tab" data-bs-target="#contact-tab3-pane" 
                      type="button" role="tab" aria-controls="contact-tab3-pane" aria-selected="false">Social</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <Link to={"/ecosystem"} className="nav-link"  aria-selected="false">View all</Link>
                    </li>
                    
                  </ul>
                  
                  <div className="tab-content pt-4 d-md-block d-none" id="myTabContent">
                    <div className="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab">
                      <div className="row no-wrap">
                      <div className="col-md-2 col-5">
                          <a href='https://www.availproject.org/' target={"_blank"} className="app-card">
                            <img src="assets/partner/app4.svg" alt="" />
                            <p className='mb-0'>Avail Network</p>
                          </a>
                        </div>
                        <div className="col-md-2 col-5">
                          <a href='https://testnet.bitlen.io/' target={"_blank"} className="app-card">
                            <img src="assets/partner/app3.svg" alt="" />
                            <p className='mb-0'>BitLen</p>
                          </a>
                        </div>
                        <div className="col-md-2 col-5">
                          <a href='https://bitomni.io/en' target={"_blank"} className="app-card">
                            <img src="assets/ecosystem/apps/ap5.png" style={{maxWidth: "60px"}} alt="" />
                            <p className='mb-0'>Bitomni</p>
                          </a>
                        </div>
                        <div className="col-md-2 col-5">
                          <a href='https://www.blockscout.com/' target={"_blank"} className="app-card">
                            <img src="assets/partner/app5.svg" alt="" />
                            <p className='mb-0'>Blockscout</p>
                          </a>
                        </div>
                        <div className="col-md-2 col-5">
                          <a href='https://icecreamswap.com/' target={"_blank"} className="app-card">
                            <img src="assets/partner/app1.svg" alt="" />
                            <p className='mb-0'>IceCreamSwap</p>
                          </a>
                        </div>
                        
                        <div className="col-md-2 col-5">
                          <Link to={"/ecosystem"} className="app-card">
                            <div className='mt-4 pt-3 mb-2'>
                            <svg width="53" height="13" viewBox="0 0 53 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M53 6.5L43 0.726497V12.2735L53 6.5ZM0 7.5H44V5.5H0V7.5Z" fill="white"/>
                            </svg>
                            </div>
                            <Link to={"/ecosystem"} >View more</Link>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab">
                    <div className="row no-wrap">
                    {categories
                        .filter((category) => category.name.toLowerCase() === "defi")
                        .map((category, index) => (
                          <>
                            {category.items.slice(0, 5).map((item, index) => (
                              <div className="col-md-2 col-5" key={index}>
                                <a href={item.link} target={"_blank"} className="app-card">
                                  <img src={item.image} alt={item.name} style={{ maxWidth: "60px" }} />
                                  <p>{item.name}</p>
                                </a>
                              </div>

                            ))}
                        {category.items.length > 5 && (
                      <div className="col-md-2 col-5">
                          <a href='javascript:void(0)' className="app-card">
                            <div className='mt-4 pt-3 mb-2'>
                            <svg width="53" height="13" viewBox="0 0 53 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M53 6.5L43 0.726497V12.2735L53 6.5ZM0 7.5H44V5.5H0V7.5Z" fill="white"/>
                            </svg>
                            </div>
                            <Link to={"/ecosystem"} >View more</Link>
                          </a>
                        </div>
                        )}
                          </>
                        ))}
                    </div>

                    </div>
                    <div className="tab-pane fade" id="contact-tab-pane" role="tabpanel" aria-labelledby="contact-tab">
                    <div className="row no-wrap">
                    {categories
                        .filter((category) => category.name === "Infra & Tooling")
                        .map((category, index) => (
                          <>
                            {category.items.slice(0, 5).map((item, index) => (
                              <div className="col-md-2 col-5" key={index}>
                                <a href={item.link} target={"_blank"} className="app-card">
                                  <img src={item.image} alt={item.name} style={{ maxWidth: "60px" }} />
                                  <p>{item.name}</p>
                                </a>
                              </div>

                            ))}
                        {category.items.length > 5 && (
                      <div className="col-md-2 col-5">
                          <a href='javascript:void(0)' className="app-card">
                            <div className='mt-4 pt-3 mb-2'>
                            <svg width="53" height="13" viewBox="0 0 53 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M53 6.5L43 0.726497V12.2735L53 6.5ZM0 7.5H44V5.5H0V7.5Z" fill="white"/>
                            </svg>
                            </div>
                            <Link to={"/ecosystem"} >View more</Link>
                          </a>
                        </div>
                        )}
                          </>
                        ))}
                    </div>
                    </div>
                    <div className="tab-pane fade" id="contact-tab1-pane" role="tabpanel" aria-labelledby="contact-tab1">
                    <div className="row no-wrap">
                    {categories
                        .filter((category) => category.name === "Wallets")
                        .map((category, index) => (
                          <>
                            {category.items.slice(0, 5).map((item, index) => (
                              <div className="col-md-2 col-5" key={index}>
                                <a href={item.link} target={"_blank"} className="app-card">
                                  <img src={item.image} alt={item.name} style={{ maxWidth: "60px" }} />
                                  <p>{item.name}</p>
                                </a>
                              </div>

                            ))}
                        {category.items.length > 5 && (
                      <div className="col-md-2 col-5">
                          <a href='javascript:void(0)' className="app-card">
                            <div className='mt-4 pt-3 mb-2'>
                            <svg width="53" height="13" viewBox="0 0 53 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M53 6.5L43 0.726497V12.2735L53 6.5ZM0 7.5H44V5.5H0V7.5Z" fill="white"/>
                            </svg>
                            </div>
                            <Link to={"/ecosystem"} >View more</Link>
                          </a>
                        </div>
                        )}
                          </>
                        ))}
                    </div>
                    </div>
                    <div className="tab-pane fade" id="contact-tab2-pane" role="tabpanel" aria-labelledby="contact-tab2">
                    <div className="row no-wrap">
                    {categories
                        .filter((category) => category.name === "Bridge")
                        .map((category, index) => (
                          <>
                            {category.items.slice(0, 5).map((item, index) => (
                              <div className="col-md-2 col-5" key={index}>
                                <a href={item.link} target={"_blank"} className="app-card">
                                  <img src={item.image} alt={item.name} style={{ maxWidth: "60px" }} />
                                  <p>{item.name}</p>
                                </a>
                              </div>

                            ))}
                        {category.items.length > 5 && (
                      <div className="col-md-2 col-5">
                          <a href='javascript:void(0)' className="app-card">
                            <div className='mt-4 pt-3 mb-2'>
                            <svg width="53" height="13" viewBox="0 0 53 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M53 6.5L43 0.726497V12.2735L53 6.5ZM0 7.5H44V5.5H0V7.5Z" fill="white"/>
                            </svg>
                            </div>
                            <Link to={"/ecosystem"} >View more</Link>
                          </a>
                        </div>
                        )}
                          </>
                        ))}
                    </div>
                    </div>
                    <div className="tab-pane fade" id="contact-tab3-pane" role="tabpanel" aria-labelledby="contact-tab3">
                    <div className="row no-wrap">
                    {categories
                        .filter((category) => category.name === "Social")
                        .map((category, index) => (
                          <>
                            {category.items.slice(0, 5).map((item, index) => (
                              <div className="col-md-2 col-5" key={index}>
                                <a href={item.link} target={"_blank"} className="app-card">
                                  <img src={item.image} alt={item.name} style={{ maxWidth: "60px" }} />
                                  <p>{item.name}</p>
                                </a>
                              </div>

                            ))}
                        {category.items.length > 5 && (
                      <div className="col-md-2 col-5">
                          <a href='javascript:void(0)' className="app-card">
                            <div className='mt-4 pt-3 mb-2'>
                            <svg width="53" height="13" viewBox="0 0 53 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M53 6.5L43 0.726497V12.2735L53 6.5ZM0 7.5H44V5.5H0V7.5Z" fill="white"/>
                            </svg>
                            </div>
                            <Link to={"/ecosystem"} >View more</Link>
                          </a>
                        </div>
                        )}
                          </>
                        ))}
                    </div>
                    </div>
                    {/* <div className="tab-pane fade" id="contact-tab4-pane" role="tabpanel" aria-labelledby="contact-tab4"></div> */}

                  </div>

                  <div className="tab-content pt-4 d-md-none d-block">
                  <div className="row no-wrap">
                  {filteredCategories.map((category) =>
                            category.items.slice(0, 5).map((item, index) => (
                              <div className="col-md-2 col-5" key={index}>
                                <a href={item.link} target={"_blank"} className="app-card">
                                  <img src={item.image} alt={item.name} style={{ maxWidth: "60px" }} />
                                  <p>{item.name}</p>
                                </a>
                              </div>
                            ))
                          )}

                          {filteredCategories.map((category) =>
                            category.items.length >= 5 && (
                              <div className="col-md-2 col-5" key={category.name}>
                                <a href='javascript:void(0)' className="app-card">
                                  <div className='mt-4 pt-3 mb-2'>
                                    <svg width="53" height="13" viewBox="0 0 53 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M53 6.5L43 0.726497V12.2735L53 6.5ZM0 7.5H44V5.5H0V7.5Z" fill="white" />
                                    </svg>
                                  </div>
                                  <Link to={"/ecosystem"}>View more</Link>
                                </a>
                              </div>
                            )
                          )}
                    </div>
                  </div>
              </div>
            </div>
            
          </div>
          
        </div>
      </div>
      <div className="d-md-none d-block mt-4">
                  <Link to={"/ecosystem"} className="primary-btn w-100">View All Apps  </Link>
                  </div>
    </div>
        </section>

        <section className='pt-lg-5'>
          <div className="container">
            <div className="solo-card">
              <div className="row align-items-center">
                <div className="col-md-12">
                <h3 className='mb-4 d-md-none text-start d-block'>Dive into the StratoVM Universe</h3>
                </div>
                <div className="col-md-6 col-11 mx-auto mb-md-0 mb-4 text-center">
                  <img src="assets/solo.png" className='w-100 mx-350' alt="" />
                </div>
                <div className="col-md-6">
                  <h3 className='mb-4 d-md-block d-none' >Dive into the StratoVM Universe</h3>

                  <div className="accordion" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingOne">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" 
                        aria-expanded="false" aria-controls="collapseOne">
                          <div className='d-flex align-items-center gap-3'><img src="assets/fav.png" height={35} alt="" /> <span className="white-text">StratoVM Testnet</span></div>
                          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.3063 7.26599L22.4778 13.4374H4.0625C4.00856 13.4374 3.95528 13.4402 3.90274 13.4456C3.11484 13.5256 
                            2.5 14.1909 2.5 14.9999C2.5 15.8629 3.19955 16.5624 4.0625 16.5624H22.4778L16.3063 22.7339C15.6961 23.3442 15.6961 
                            24.3334 16.3063 24.9437C16.9165 25.5538 17.9058 25.5538 18.516 24.9437L27.3549 16.1048C27.965 15.4947 27.965 14.5053 
                            27.3549 13.8951L18.516 5.05628C18.5065 5.04674 18.4969 5.03736 18.4872 5.02813C18.4192 4.96346 18.3468 4.90611 18.2709 
                            4.85606C17.8377 4.57003 17.2934 4.52236 16.8231 4.71304C16.6351 4.78931 16.4589 4.90373 16.3063 5.05628C16.2968 5.06581 
                            16.2874 5.07544 16.2782 5.08515C15.6963 5.6973 15.7057 6.66533 16.3063 7.26599Z" fill="white"/>
                            </svg>
                        </button>
                      </h2>
                      <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          {/* <h5 className=''>Shifting the paradigm of real estate investment.</h5> */}
                          <p className=' mb-0'>The Testnet is now live, offering an opportunity to explore and experiment.</p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingTwo">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <div className='d-flex align-items-center gap-3'><img src="assets/fav.png" height={35} alt="" /> <span className="white-text">Developer Resources</span></div>
                          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.3063 7.26599L22.4778 13.4374H4.0625C4.00856 13.4374 3.95528 13.4402 3.90274 13.4456C3.11484 13.5256 
                            2.5 14.1909 2.5 14.9999C2.5 15.8629 3.19955 16.5624 4.0625 16.5624H22.4778L16.3063 22.7339C15.6961 23.3442 15.6961 
                            24.3334 16.3063 24.9437C16.9165 25.5538 17.9058 25.5538 18.516 24.9437L27.3549 16.1048C27.965 15.4947 27.965 14.5053 
                            27.3549 13.8951L18.516 5.05628C18.5065 5.04674 18.4969 5.03736 18.4872 5.02813C18.4192 4.96346 18.3468 4.90611 18.2709 
                            4.85606C17.8377 4.57003 17.2934 4.52236 16.8231 4.71304C16.6351 4.78931 16.4589 4.90373 16.3063 5.05628C16.2968 5.06581 
                            16.2874 5.07544 16.2782 5.08515C15.6963 5.6973 15.7057 6.66533 16.3063 7.26599Z" fill="white"/>
                            </svg>
                        </button>
                      </h2>
                      <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                          {/* <h5 className=''>Shifting the paradigm of real estate investment.</h5> */}
                          <p className=' mb-0'>Check out our comprehensive developers docs and access resources to develop protocols on Bitcoin.</p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingThree">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        <div className='d-flex align-items-center gap-3'><img src="assets/fav.png" height={35} alt="" /> <span className="white-text">Accelerator Program</span></div>
                          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.3063 7.26599L22.4778 13.4374H4.0625C4.00856 13.4374 3.95528 13.4402 3.90274 13.4456C3.11484 13.5256 
                            2.5 14.1909 2.5 14.9999C2.5 15.8629 3.19955 16.5624 4.0625 16.5624H22.4778L16.3063 22.7339C15.6961 23.3442 15.6961 
                            24.3334 16.3063 24.9437C16.9165 25.5538 17.9058 25.5538 18.516 24.9437L27.3549 16.1048C27.965 15.4947 27.965 14.5053 
                            27.3549 13.8951L18.516 5.05628C18.5065 5.04674 18.4969 5.03736 18.4872 5.02813C18.4192 4.96346 18.3468 4.90611 18.2709 
                            4.85606C17.8377 4.57003 17.2934 4.52236 16.8231 4.71304C16.6351 4.78931 16.4589 4.90373 16.3063 5.05628C16.2968 5.06581 
                            16.2874 5.07544 16.2782 5.08515C15.6963 5.6973 15.7057 6.66533 16.3063 7.26599Z" fill="white"/>
                            </svg>
                        </button>
                      </h2>
                      <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                          {/* <h5 className=''>Shifting the paradigm of real estate investment.</h5> */}
                          <p className=' mb-0'>We are launching an accelerator program to support projects building on StratoVM. 
                            Follow our social media channels for updates and deadlines.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>


        <section className='py-5 my-lg-4 build' id='developer'>
          <div className="container">
              <div className="row align-items-center">
                
                <div className="col-md-6">
                  <div className='badge-b mb-4'>Ecosystem fund</div>
                  <h2 className='mb-4'>Build the StratoVM ecosystem</h2>
                  <p className=''><b>$1,000,000</b> in $SVM allocation for ecosystem developers</p>
                  
                  <div className="d-flex flex-md-row flex-column gap-3 mb-md-0 mb-4 pt-4">
                <a href="https://medium.com/@StratoVM_/stratovm-accelerator-program-fueling-innovation-in-defi-on-bitcoin-8f42abc9df15"
                target={"_blank"} className='primary-btn'>Register now</a>
                <a href="https://discord.com/invite/StratoVM" target={"_blank"} className='secondary-btn'>Get help </a>
                </div>
                </div>
                <div className="col-md-6 text-center">
                  <img src="assets/eco.png" className='w-100 op-dark' alt="" />
                  <img src="assets/eco-vm.png" className='w-100 op-light' alt="" />
                </div>
              </div>
          </div>
        </section>

        <section className='secure'>
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-md-5 border-end">
                <h1 className='mb-0 text-center'>$1,000,000</h1>
              </div>
              <div className="col-md-6 ps-md-5">
                <p className='mb-0 mt-md-0 mt-4 text-md-start text-center'>Secure $SVM allocation in mainnet for deploying 
                  <br className='d-md-block d-none' /> dApps to 
                  StratoVM in testnet and mainnet phases</p>
              </div>
            </div>
          </div>
        </section>

        <section className='launch'>
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-8">
                      {/* <div className='vm-text'>StratoVM <span>Cloud</span></div> */}
                      <div className="text-center pt-md-4">
                  <div className='badge-b mb-4'>For Projects</div>
                        <h2 className='mb-4'>Launch and Grow on <span>StratoVM</span></h2>
                        <p>The modular DeFi L2 is designed to enable new economic systems to grow, offering transaction costs of 
                          less than $0.001 and a block time of just 2 seconds.</p>
                      </div>
                  </div>
                </div>
              </div>
        </section>

        <section className='my-5 py-lg-5'>
          <div className="container">
            <div className="row">
              <div className="col-md-6 mb-md-0 mb-4">
                <div className="left-aside">
                  <div className="text-md">Builder</div>
                  <h3 className='my-3'>Do you have a project and are keen to develop it on StratoVM?</h3>
                  <p className=''>We are eager to foster the growth of our ecosystem, 
                    welcoming the best teams and ideas into the Bitcoin landscape.</p>
                    <a href="https://forms.gle/NXj9zaq2AMSFndmD6" target={"_blank"} className='primary-btn'>Submit your project</a>
                </div>
              </div>

              <div className="col-md-6">
                <div className="right-aside">
                  <div className="text-md text-black">Supporter</div>
                  <h3 className='my-3'>Interested in accessing exclusive opportunities?</h3>
                  <p className=' text-black'>We offer a curated selection of promising projects available 
                    exclusively through our invite-only dashboard!</p>
                    <a href="https://discord.gg/StratoVM" target={"_blank"} className='primary-btn'>Join Now</a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className='news' id='news'>
          <div className="container">
              <div className="text-center">
                <h2 className='mb-4'>Featured News</h2>
              </div>
              <div className="row pt-3" >
              <div className='col mb-4'>
                      <a href='https://news.bitcoin.com/stratovm-revolutionizing-bitcoins-defi-landscape/'
                      target={"_blank"} className="swiper-box">
                        <div className="swiper-img">
                          <img src="/assets/n2.png" className='w-100' alt="" />
                        </div>
                        <p className='d-md-none d-block'>StratoVM: Revolutionizing Bitcoin's DeFi Landscape</p>
                      </a>
                    </div>
                    <div className='col mb-4'>
                      <a href='https://www.coindesk.com/press-release/2024/08/14/stratovm-introduces-defi-solutions-anchored-in-bitcoins-security/'
                      target={"_blank"} className="swiper-box">
                        <div className="swiper-img">
                          <img src="/assets/n5.png" className='w-100' alt="" />
                        </div>
                        <p className='d-md-none d-block'>StratoVM Introduces DeFi Solutions Anchored in Bitcoin's Security</p>
                      </a>
                    </div>
                    <div className='col mb-4'>
                      <a href='https://finance.yahoo.com/news/stratovm-bringing-power-defi-bitcoins-125500871.html'
                      target={"_blank"} className="swiper-box">
                        <div className="swiper-img">
                          <img src="/assets/n4.png" className='w-100' alt="" />
                        </div>
                        <p className='d-md-none d-block'>StratoVM: Bringing the Power of DeFi to Bitcoin's Secure Foundation</p>
                      </a>
                    </div>
              <div className='col mb-4'>
                      <a href='https://finbold.com/stratovm-bringing-scalable-and-secure-defi-to-bitcoin/'
                      target={"_blank"} className="swiper-box">
                        <div className="swiper-img">
                          <img src="/assets/n1.png" className='w-100' alt="" />
                        </div>
                        <p className='d-md-none d-block'>StratoVM: Bringing Scalable and Secure DeFi to Bitcoin</p>
                      </a>
                    </div>
                    <div className='col mb-4'>
                      <a href='https://www.coinspeaker.com/stratovm-power-of-defi-on-bitcoins-secure-network/'
                      target={"_blank"} className="swiper-box">
                        <div className="swiper-img">
                          <img src="/assets/n3.png" className='w-100' alt="" />
                        </div>
                        <p className='d-md-none d-block'>StratoVM: Unlocking the Power of DeFi on Bitcoin’s Secure Network</p>
                      </a>
                    </div>
                    
                    
                  </div>
                  <div className="text-center mt-md-5">
                <a href="#news" className='primary-btn'>See all news</a>
              </div>

            </div>
        </section>

        <section className='my-5 py-lg-5'>
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-md-5 mb-md-0 mb-4">
                <a href="https://medium.com/@StratoVM_" target={"_blank"} className='news-btn'><div>Blog</div>
                <svg width="53" height="13" viewBox="0 0 53 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M53 6.5L43 0.726497V12.2735L53 6.5ZM0 7.5H44V5.5H0V7.5Z" fill="white"/>
                </svg></a>
              </div>
              <div className="col-md-5">
                <a href="#news" className='news-btn'><div>Press</div>
                <svg width="53" height="13" viewBox="0 0 53 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M53 6.5L43 0.726497V12.2735L53 6.5ZM0 7.5H44V5.5H0V7.5Z" fill="white"/>
                </svg></a>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-5 mb-md-0 mb-4">
                <div className="fw-500 fs-18 mb-2">Sign up for exclusive news</div>
                <NewsLetter />
              </div>

              <div className="col-md-5">
                <div className="d-flex gap-2 justify-content-md-end justify-content-center">
                
                    <a href="https://discord.gg/StratoVM" target={"_blank"} className="social-ic">
                    <svg width="28" height="19" viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.16892 15.212C12.2582 17.5624 17.4402 18.0203 23.3125 14.3617C23.2695 14.4256 22.1079 16.1277 19.0532 17C19.6985 17.8724 20.5806 18.8723 20.5806 18.8723C22.5381 18.8723 24.4527 18.3191 26.109 17.2553C27.3997 16.4042 28.1311 14.9362 27.9805 13.4043C27.7224 10.7872 27.0985 8.23405 26.1305 5.78729C24.9044 2.59582 21.9573 0.383032 18.5369 0.0638598C18.2358 0.0425732 18.0207 0.0425734 17.8916 0.0425734L17.5475 0.382969C21.4841 1.48937 23.4417 3.21276 23.4846 3.27662C17.4399 0.255312 10.298 0.212802 4.21019 3.14896C4.21019 3.14896 6.14625 1.25534 10.427 0.255313L10.1689 0C9.71713 0 9.28689 0.042573 8.83519 0.10637C5.67296 0.638281 3.02707 2.78721 1.88693 5.74466C0.897379 8.29785 0.252046 10.9787 0.0154353 13.7021C-0.113631 15.1489 0.574745 16.5745 1.77939 17.4043C3.37123 18.4468 5.26424 19 7.17878 19C7.17878 19 7.95318 18 8.72764 17.1064C5.82355 16.2553 4.64043 14.5532 4.61891 14.4893L5.16545 14.7654C5.49217 14.9305 5.82713 15.08 6.16892 15.212ZM9.54508 13.3617C8.14681 13.3191 7.04972 12.1489 7.09276 10.7447C7.1358 9.42553 8.21138 8.36171 9.54508 8.31913C10.9434 8.36171 12.0405 9.5319 11.9974 10.9362C11.9328 12.2554 10.8788 13.3192 9.54508 13.3617ZM18.3218 13.3617C16.9235 13.3191 15.8264 12.1489 15.8695 10.7447C15.9125 9.42553 16.9881 8.36171 18.3218 8.31913C19.7201 8.36171 20.8172 9.5319 20.7741 10.9362C20.7311 12.2554 19.6555 13.3192 18.3218 13.3617Z" fill="white"/>
                    </svg></a>
                    <a href="https://twitter.com/StratoVM_" target={"_blank"} className="social-ic">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_740_1704)">
                    <path d="M13.0458 9.3155L21.0597 0H19.1607L12.2022 8.08852L6.64453 0H0.234375L8.63871 12.2313L0.234375 22H2.13352L9.48183 13.4583L15.3512 22H21.7613L13.0454 9.3155H13.0458ZM10.4447 12.339L9.59316 11.1211L2.81781 1.42964H5.73478L11.2026 9.25094L12.0541 10.4689L19.1616 20.6354H16.2446L10.4447 12.3395V12.339Z" fill="white"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_740_1704">
                    <rect width="22" height="22" fill="white"/>
                    </clipPath>
                    </defs>
                    </svg> </a>
                    <a href="https://medium.com/@StratoVM_" target={"_blank"} className="social-ic">
                    <svg width="28" height="16" viewBox="0 0 28 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.7935 7.99979C15.7935 12.391 12.258 15.9508 7.89677 15.9508C3.53549 15.9508 0 12.391 0 7.99979C0 3.6086 3.53549 0.0488281 7.89677 0.0488281C12.258 0.0488281 15.7935 3.6086 15.7935 7.99979Z" fill="white"/>
                    <path d="M24.4593 8.00005C24.4593 12.1336 22.6915 15.4845 20.5109 15.4845C18.3303 15.4845 16.5625 12.1336 16.5625 8.00005C16.5625 3.86649 18.3303 0.515625 20.5109 0.515625C22.6915 0.515625 24.4593 3.86649 24.4593 8.00005Z" fill="white"/>
                    <path d="M28.0039 7.99967C28.0039 11.7032 27.3821 14.7054 26.6152 14.7054C25.8482 14.7054 25.2266 11.7032 25.2266 7.99967C25.2266 4.29618 25.8482 1.29395 26.6152 1.29395C27.3821 1.29395 28.0039 4.29618 28.0039 7.99967Z" fill="white"/>
                    </svg></a>
                    <a href="https://github.com/StratoVM" target={"_blank"} className="social-ic">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.6rem" height="1.6rem" viewBox="0 0 24 24"><path fill="white" d="M12 2A10 10 0 0 0 2 12c0 4.42 2.87 8.17 6.84 9.5c.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34c-.46-1.16-1.11-1.47-1.11-1.47c-.91-.62.07-.6.07-.6c1 .07 1.53 1.03 1.53 1.03c.87 1.52 2.34 1.07 2.91.83c.09-.65.35-1.09.63-1.34c-2.22-.25-4.55-1.11-4.55-4.92c0-1.11.38-2 1.03-2.71c-.1-.25-.45-1.29.1-2.64c0 0 .84-.27 2.75 1.02c.79-.22 1.65-.33 2.5-.33s1.71.11 2.5.33c1.91-1.29 2.75-1.02 2.75-1.02c.55 1.35.2 2.39.1 2.64c.65.71 1.03 1.6 1.03 2.71c0 3.82-2.34 4.66-4.57 4.91c.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0 0 12 2"/></svg>
                    </a>
                    
                    <a href="https://t.me/StratoVMAnnouncements" target={"_blank"} className="social-ic">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1245_98)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0ZM17.562 8.161C17.382 10.058 16.6 14.663 16.203 16.788C16.035 17.688 15.703 17.989 15.383 18.018C14.686 18.082 14.157 17.557 13.482 17.115C12.426 16.423 11.829 15.992 10.804 15.316C9.619 14.535 10.387 14.106 11.062 13.405C11.239 13.221 14.309 10.428 14.369 10.175C14.376 10.143 14.384 10.025 14.313 9.963C14.242 9.901 14.139 9.922 14.065 9.939C13.959 9.963 12.272 11.078 9.003 13.284C8.524 13.613 8.09 13.773 7.701 13.765C7.273 13.756 6.449 13.523 5.836 13.323C5.085 13.079 4.487 12.949 4.539 12.535C4.566 12.319 4.863 12.098 5.431 11.872C8.929 10.348 11.262 9.343 12.429 8.857C15.762 7.471 16.454 7.23 16.906 7.222C17.472 7.214 17.608 7.681 17.562 8.161Z" fill="white"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_1245_98">
                      <rect width="24" height="24" fill="white"/>
                      </clipPath>
                      </defs>
                      </svg>
                      </a>
                      <a href="https://app.galxe.com/quest/X8QrV4cqcjYssXZ2EpS6va" target={"_blank"} className="social-ic">
                      <img src="assets/galex.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>



<div className="modal fade border-0" id="exampleModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable m-0">
    <div className="modal-content">
      
      <div className="modal-body">
      <ul className="nav nav-tabs flex-column border-0" id="myTab" role="tablist">
  <li className="nav-item" role="presentation">
    <button
      className={`nav-link ${selectedCategory === "Featured dApps" ? "active" : ""}`}
      onClick={() => handleCategorySelect("Featured dApps")}
      data-bs-dismiss="modal"
    >
      Featured dApps
    </button>
  </li>

  {data.categories
    .filter(category => !excludedCategories.includes(category.name.toLowerCase()))
    .map((category, index) => (
      <li className="nav-item" role="presentation" key={index}>
        <button
          className={`nav-link ${selectedCategory === category.name ? "active" : ""}`}
          onClick={() => handleCategorySelect(category.name)}
          data-bs-dismiss="modal"
        >
          {category.name}
        </button>
      </li>
    ))}

  <li className="nav-item" role="presentation" data-bs-dismiss="modal">
    <Link to={"/ecosystem"} className="nav-link primary-text w-100">View all</Link>
  </li>
</ul>
      </div>
      
    </div>
  </div>
</div>


    </>
  );
};

export default Home;
